"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const socket_io_client_1 = require("socket.io-client");
let socket;
const connect = (ioHost, classRooms) => {
    socket = (0, socket_io_client_1.io)(ioHost, {
        query: {
            classRooms,
        },
        rejectUnauthorized: false,
        transports: ['websocket'],
        reconnectionDelayMax: 20000, // 20s
        withCredentials: true,
    });
    return socket;
};
const userIsTyping = (conversationId) => {
    socket.emit('user:typing', conversationId);
};
const sendMessage = (conversationId, message) => {
    socket.emit('user:message', conversationId, message);
};
const joinConversation = (conversationId) => {
    socket.emit('user:join:conv', conversationId);
};
const joinClass = (classId) => {
    socket.emit('user:join:class', classId);
};
const subscribeByAccessToken = (accessToken) => {
    socket.emit('user:subscribeByAccessToken', accessToken);
};
const leaveConversation = (conversationId) => {
    socket.emit('user:leave:conv', conversationId);
};
const leaveClass = (classId) => {
    socket.emit('user:leave:class', classId);
};
const unsubscribeSpace = (spaceId) => {
    socket.emit('user:unsubscribeSpace', spaceId);
};
const disconnect = () => {
    socket.disconnect();
};
exports.default = {
    connect,
    userIsTyping,
    sendMessage,
    joinConversation,
    joinClass,
    subscribeByAccessToken,
    leaveConversation,
    leaveClass,
    unsubscribeSpace,
    disconnect,
};
